export default __webpack_public_path__ + "static/media/undraw_through_the_park.d93402b1.svg";